import { Component, Input } from '@angular/core';

@Component({selector:'app-stats-skeleton',templateUrl:'./stats-skeleton.component.html',styleUrls:['./stats-skeleton.component.scss']})
export class StatsSkeletonComponent {
    @Input() variant: 'overall' | 'leaderboards' | 'activity' | 'updating' = 'leaderboards';
    readonly leaders = [0,1,2];
    readonly totals = [0,1,2,3];
    get label(): string { return this.variant === 'overall' ? 'Loading overall stats' : this.variant === 'updating' ? 'Updating standings' : 'Loading leaderboards'; }
}
